import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { MdCalendarToday } from 'react-icons/md'
import { Blue300, Red300 } from '../lib/colors'
import moment, { Moment } from 'moment'
import { useI18n } from '../provider/i18n'

type DateButtonProps = {
  value?: string
  className?: string
  isError?: boolean
  onClick: () => void
}

const DateButton = ({
  value,
  className,
  isError = false,
  onClick,
}: DateButtonProps) => {
  const i18n = useI18n()
  const [currentMoment, setCurrentMoment] = useState<Moment>()

  useEffect(() => {
    const newMoment = value ? moment(value) : undefined
    setCurrentMoment(newMoment)
  }, [value])

  return (
    <button
      onClick={onClick}
      className={twMerge(
        `flex flex-row gap-3 items-center border-2 text-blue-700 font-bold rounded-xl h-12 shadow-none px-3 ${
          currentMoment && !isError ? 'border-green-700' : 'border-red-700'
        }`,
        className
      )}
    >
      <MdCalendarToday
        size={24}
        color={currentMoment && !isError ? Blue300 : Red300}
      />
      {currentMoment ? (
        <div className="flex flex-col">
          <span className={`${isError ? 'text-red-800' : ''}`}>
            {currentMoment.format('DD.MM.YYYY, HH:mm')}
          </span>
        </div>
      ) : (
        <span className="text-red-800">
          {i18n.t('components.datebutton.selectDate')}
        </span>
      )}
    </button>
  )
}

export default DateButton
